const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: {
      items: [],
      count: 0,
    },
  },
};

export default initialState;
